var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"segment"}},[_vm._t("logo"),_vm._v(" "),_vm._t("date"),_vm._v(" "),_c('div',{staticClass:"line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }